import React, { useState } from 'react';
import { X, ArrowRight, Clock, Heart, Sparkles } from 'lucide-react';

const OnboardingTutorial = ({ onClose, onComplete }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      icon: Heart,
      title: "Welcome to Your Love Journey",
      description: "Discover your unique patterns in love and relationships through our AI-powered assessments.",
      image: "❤️"
    },
    {
      icon: Clock,
      title: "Quick & Insightful",
      description: "Each test takes 5-7 minutes. Answer honestly for the most accurate insights. You can skip questions or save progress anytime.",
      image: "⏱️"
    },
    {
      icon: Sparkles,
      title: "Personalized Results",
      description: "Get AI-generated insights tailored to your responses, plus actionable recommendations to grow in love.",
      image: "✨"
    }
  ];

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      localStorage.setItem('luvcup_onboarding_completed', 'true');
      onComplete();
    }
  };

  const handleSkip = () => {
    localStorage.setItem('luvcup_onboarding_completed', 'true');
    onClose();
  };

  const slide = slides[currentSlide];
  const Icon = slide.icon;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full relative">
        {/* Close button */}
        <button
          onClick={handleSkip}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Content */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center">
            <Icon className="w-10 h-10 text-rose-600" />
          </div>
          <div className="text-6xl mb-4">{slide.image}</div>
          <h2 className="text-2xl font-bold gradient-text mb-4">{slide.title}</h2>
          <p className="text-gray-600 leading-relaxed">{slide.description}</p>
        </div>

        {/* Progress dots */}
        <div className="flex justify-center space-x-2 mb-6">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`h-2 rounded-full transition-all ${
                index === currentSlide
                  ? 'w-8 bg-rose-600'
                  : 'w-2 bg-gray-300'
              }`}
            />
          ))}
        </div>

        {/* Actions */}
        <div className="flex space-x-4">
          {currentSlide > 0 && (
            <button
              onClick={() => setCurrentSlide(currentSlide - 1)}
              className="flex-1 btn-secondary"
            >
              Back
            </button>
          )}
          <button
            onClick={handleNext}
            className="flex-1 btn-primary flex items-center justify-center"
          >
            {currentSlide === slides.length - 1 ? "Get Started" : "Next"}
            <ArrowRight className="w-5 h-5 ml-2" />
          </button>
        </div>

        {/* Skip link */}
        {currentSlide < slides.length - 1 && (
          <button
            onClick={handleSkip}
            className="w-full text-center text-sm text-gray-500 hover:text-gray-700 mt-4"
          >
            Skip tutorial
          </button>
        )}
      </div>
    </div>
  );
};

export default OnboardingTutorial;
